/**
 * Two-column picker options: identifier, then name (Wave Experience A). A native select
 * cannot hold table cells, so the identifier column is padded to the widest identifier
 * of the list with no-break spaces and the select draws in the monospaced face
 * (`PICKER_CLASS`): the names then start on one line, open or closed, on every platform.
 *
 * Author: Mahmoud Ragab Ahmed.
 */

/** The class a two-column select carries: the monospaced face keeps the columns. */
export const PICKER_CLASS = "font-mono";

const GAP = "   ";

/** The widest identifier of a list, the identifier column's width. */
export function pickerWidth(identifiers: readonly string[]): number {
  return identifiers.reduce((widest, one) => Math.max(widest, one.length), 0);
}

/** One option's text: the identifier padded to the column, then the name. */
export function pickerLabel(identifier: string, name: string | null, width: number): string {
  const padded = identifier.padEnd(width, " ");
  return name === null || name === "" ? identifier : `${padded}${GAP}${name}`;
}

export function PickerOption({
  value,
  identifier,
  name,
  width,
}: {
  readonly value: string;
  readonly identifier: string;
  readonly name: string | null;
  readonly width?: number;
}): React.JSX.Element {
  return (
    <option value={value} data-identifier={identifier} data-name={name ?? ""}>
      {pickerLabel(identifier, name, width ?? identifier.length)}
    </option>
  );
}
